export default class VideoOverlay {
  constructor() {
    this.DOM = {
      el: document.querySelector('[data-video-overlay="el"]'),
      iframeEl: document.querySelector('[data-video-overlay="el"] iframe'),
      closeEl: document.querySelector('[data-video-overlay="close"]')
    }
  }

  init() {
    if (!this.DOM.el || !this.DOM.closeEl) return;
    this.DOM.triggerEls = document.querySelectorAll('[data-video-overlay="trigger"]');
    this.bindEvents();
  }

  bindEvents() {
    this.DOM.triggerEls.forEach(el => el.addEventListener('click', this.onTriggerClick.bind(this)));
    this.DOM.closeEl.addEventListener('click', this.onCloseClick.bind(this));
  }

  onTriggerClick(e) {
    e.preventDefault();
    const videoUrl = e.currentTarget.getAttribute('data-video-overlay-url');
    this.DOM.iframeEl.setAttribute('src', `${videoUrl}?autoplay=1`);
    this.DOM.el.classList.add('is-open');
  }

  onCloseClick(e) {
    e.preventDefault();
    this.DOM.iframeEl.setAttribute('src', '');
    this.DOM.el.classList.remove('is-open');
  }
}